import React, { useState, useEffect } from "react";
import ListingCard from "../ListingCard";
import { getClientSavedListings, getListingDetails } from '../../utils/apiHandler';
import { IoIosArrowBack } from "react-icons/io";

const SavedListings = ({ clientId, setShowSavedListing, getIdTokenClaims, handleNotesPopup, saveUnsaveListing, getAccessTokenWithPopup, logout}) => {
    const [savedListings, setSavedListings] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setSavedListings([]);
        if (clientId) {
            fetchSavedListings()
        }
    }, [clientId]);

    const fetchSavedListings = async () => {
        let savedListingsArray = [];
        let data = await getClientSavedListings(getIdTokenClaims, clientId, getAccessTokenWithPopup, logout)

        Object.keys(data).forEach((answer_hash) => {
            getListingDetails(getIdTokenClaims, answer_hash, getAccessTokenWithPopup, logout).then((response) => {
                response.answer_hash = answer_hash
                response.notes = data[answer_hash].notes
                savedListingsArray = [...savedListingsArray, response];
                setSavedListings(savedListingsArray);
            });
        });
        
        setTimeout(() => {
            setLoading(false);
        }, 1000);
    }

    const handleSaveUnSaveListing = async (favorite, answerhash) => {
        await saveUnsaveListing(favorite,answerhash)
        const updatedListing = savedListings.filter(listing => listing.answer_hash !== answerhash);
        setSavedListings(updatedListing)
    }

    return (
        <div id="savedListingComponent" className="mt-2 ms-2 me-2 lg:ms-auto lg:me-auto">
            <div className="flex gap-2 cursor-pointer mb-6" onClick={() => setShowSavedListing(false)}>
                <IoIosArrowBack size={22} className="text-sm text-[#101828]" />
                <span className="text-base text-[#101828] font-medium hover:underline">Back to chat</span>
            </div>
            <div className="relative flex flex-col justify-center items-center px-3">
                <h1 className="text-black font-semibold text-4xl text-center w-full mb-3">
                    Here are the property you've saved
                </h1>
                <p className="lg:max-w-[80%] text-center text-[#596570]">
                    Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae
                </p>
            </div>
            <div id="savedListingGrid">
                <div id="savedListing" className="grid pt-6 pb-6 lg:pt-8 lg:pb-8 gap-4">
                    {
                        savedListings.length > 0 ? (
                            savedListings.map((listing, index) => 
                            <ListingCard 
                                key={listing.answer_hash} 
                                listing={listing} 
                                clientId = {clientId}
                                setNotesPopup={handleNotesPopup}  
                                saveUnsaveListing = {handleSaveUnSaveListing} 
                                savedListingView = {true}
                            />)
                        ) :
                            <div className="text-center">
                                {
                                    loading ?
                                        <div className="flex items-center justify-center">
                                            <div className="flex space-x-2 px-3 items-center justify-center">
                                                <div className="w-2 h-2 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-1 mt-[8px]"></div>
                                                <div className="w-2 h-2 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-2 mt-[8px]"></div>
                                                <div className="w-2 h-2 bg-gray-500 rounded-full animate-dot-wave animate-dot-delay-3 mt-[8px]"></div>
                                            </div>
                                        </div>
                                        :
                                        <span>You don't have any listings for this client!</span>
                                }
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default SavedListings;